import * as Sentry from '@sentry/browser';

Sentry.init({
	dsn: 'https://7ecf1b6b9baf5d59c2bda01e169b404a@o55978.ingest.us.sentry.io/4508084849541120',
	ignoreErrors: [
		// These are unhandled server-errors, they don't need to be tracked in Sentry
		// instead we should monitor the backend for the same exceptions and handle them accordingly
		// sending to sentry just adds noise
		/Unhandled CSM exception/i,
		// Network errors are transient and don't require tracking. Example: https://atlassian-2y.sentry.io/issues/5991793210/events/acf82556b32145ef81496d8f3de61f38/?project=4508084849541120
		/network error/i,
	],
	environment: process.env.CAWI_ENV === 'prod' ? 'production' : 'staging',
	initialScope: {
		user: {
			id: 'UNKNOWN_AAID',
		},
		tags: {
			packageName: '@atlassian/conversation-assistant-widget-installer',
			product: 'csm',
		},
	},
	attachStacktrace: true,
});
